export default {
	"author.phoneLabel": "Tel.:",
	"author.emailLabel": "E-Mail:",
} as const;
